import React, { Component } from 'react';
import _ from 'lodash';
import '@styles/exames-procedimentos.css';
import ExameAutorizado from './exame_autorizado';
import ExameNaoAutorizado from './exame_nao_autorizado';
import BeneficiarioInelegivel from './beneficiario_inelegivel';
import ExameParcialmenteAutorizado from './exame_parcialmente_autorizado';
import ExameEmAnalise from './exame_em_analise';
import ApiError from './api_error';
import AreaResultadoError from './area_resultado_error';

class AreaResultado extends Component {

    constructor(props) {
        super(props);

        this.state = {
            closeAccordions: true,
            resetingStates: false,
        };

        this.handleKeyDown = this.handleKeyDown.bind(this);
    }

    componentDidMount() {
        document.addEventListener("keydown", this.handleKeyDown, false);
    }

    componentWillUnmount() {
        document.removeEventListener("keydown", this.handleKeyDown, false);
    }

    handleKeyDown(event) {
        if (event.key === 'Enter' && this.props.activeAccordion !== '1' && this.props.activeAccordion !== '2' && this.props.activeAccordion !== '3') {
            this.props.resetAllStates();
        }
    }

    componentWillReceiveProps(nextProps) {
        const { beneficiario } = nextProps;
        if (beneficiario && beneficiario.data && beneficiario.data.elegibilidade && beneficiario.data.elegibilidade.data && beneficiario.data.elegibilidade.indicadorElegibilidade === "N") {
            if (this.state.closeAccordions) {
                this.setState({ closeAccordions: false });
                this.props.closeAllAccordions();
            }
        } else {
            this.setState({ closeAccordions: true });
        }
    }

    onCopiarClick = ({ target: { innerHTML } }) => {
        this.clickChild()
    }

    onCopy = () => {
        this.setState({ copied: true });
    }

    render() {

        const { beneficiario, exameResultado, apiError, msgErrorApi } = this.props;

        if(apiError)
            return (<AreaResultadoError msgErrorApi={msgErrorApi} resetAllStates={this.props.resetAllStates} />);

        if (beneficiario && beneficiario.data && beneficiario.data.Elegibilidade && beneficiario.data.Elegibilidade.IndicadorElegibilidade === "N") {
            return (
                <BeneficiarioInelegivel beneficiario={beneficiario} resetAllStates={this.props.resetAllStates} />
            )
        } else if (exameResultado && exameResultado.data && exameResultado.data.SolicitacaoProcedimento && exameResultado.data.SolicitacaoProcedimento.Senha && exameResultado.data.SolicitacaoProcedimento.StatusSolicitacao != null) {
            if (exameResultado.data.SolicitacaoProcedimento.StatusSolicitacao === "AUTORIZADO PARCIALMENTE") {
                return (
                    <ExameParcialmenteAutorizado exameResultado={exameResultado} resetAllStates={this.props.resetAllStates} fetchGuia={this.props.fetchGuia} displayAutorizacaoResultTable={this.props.displayAutorizacaoResultTable} />
                );
            } else if (exameResultado.data.SolicitacaoProcedimento.StatusSolicitacao === "EM ANÁLISE") {
                return (
                    <ExameEmAnalise exameResultado={exameResultado} resetAllStates={this.props.resetAllStates} displayAutorizacaoResultTable={this.props.displayAutorizacaoResultTable} />
                );
            } else {
                return (
                    <ExameAutorizado exameResultado={exameResultado} resetAllStates={this.props.resetAllStates} fetchGuia={this.props.fetchGuia} />
                );
            }
        } else if (exameResultado === 'API_ERROR') {
            return (
                <ApiError resetAllStates={this.props.resetAllStates} exame={this.props.exame} />
            )
        } else if (!_.isEmpty(exameResultado)) {
            if (exameResultado.data
                && exameResultado.data.SolicitacaoProcedimento
                && exameResultado.data.SolicitacaoProcedimento.StatusSolicitacao != null) {
                if (exameResultado.data.SolicitacaoProcedimento.StatusSolicitacao === "EM ANÁLISE")
                    return (
                        <ExameEmAnalise exameResultado={exameResultado} resetAllStates={this.props.resetAllStates} displayAutorizacaoResultTable={this.props.displayAutorizacaoResultTable} />
                    );
            }
            return (
                <ExameNaoAutorizado resetAllStates={this.props.resetAllStates} exame={this.props.exame} />
            )
        } else
            return <div></div>

    }
}

export default AreaResultado